import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAutocomplete,{attrs:{"items":_vm.clients,"small-chips":"","deletable-chips":"","label":_vm.$t('labels.clients'),"hint":_vm.$t('selectClientsHint'),"item-text":"display","return-object":"","append-icon":_vm.$vuetify.icons.values.add,"hide-no-data":"","hide-selected":"","multiple":"","loading":_vm.loading,"disabled":_vm.readonly,"menu-props":{
      closeOnContentClick: true
    }},on:{"click:append":_vm.create},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }